export enum GridFilterType {
  TEXT = 'agTextColumnFilter',
  NUMBER = 'agNumberColumnFilter',
  NUMBER_NO_FILTER = 'agNumberColumnNoFilter',
  DATE = 'agDateColumnFilter',
  DATETIME = 'customDateTime',
  SET = 'agSetColumnFilter',
  MAPLECROFT_RISK_VIEW = 'customMaplecroftRiskViewFilter',
  SITE_NAME = 'agSiteTextColumnFilter',
  CUSTOM_TEXT_ATTRIBUTE = 'agCustomTextColumnFilter',
}
